export const eventsWhiteList = [
  "TWITTER_LOGIN_START",
  "TWITTER_LOGIN_SUCCESS",
  "TWITTER_LOGIN_FAIL",
  "TWITTER_SIGN_OUT_START",
  "TWITTER_SIGN_OUT_FAIL",
  "TWITTER_SIGN_OUT_SUCCESS",
  "DESO_LOGIN_SUCCESS",
  "FETCH_TWITTER_TIMELINE_START",
  "FETCH_TWITTER_TIMELINE_SUCCESS",
  "FETCH_TWITTER_TIMELINE_FAIL",
  "POST_DATA_START",
  "POST_DATA_PARTIAL_SUCCESS",
  "POST_DATA_SUCCESS",
  "POST_DATA_FAIL",
  "SET_IS_DESO_BALANCE_MODAL",
];
export const eventListMap = {
  TWITTER_LOGIN_START: "twitter_login_clicked",
  TWITTER_LOGIN_SUCCESS: "twitter_login_success",
  TWITTER_LOGIN_FAIL: "twitter_login_fail",
  TWITTER_SIGN_OUT_START: "twitter_signout_start",
  TWITTER_SIGN_OUT_FAIL: "twitter_signout_fail",
  TWITTER_SIGN_OUT_SUCCESS: "twitter_signout_success",
  DESO_LOGIN_SUCCESS: "deso_login_success",
  FETCH_TWITTER_TIMELINE_START: "fetch_twitter_timeline",
  FETCH_TWITTER_TIMELINE_SUCCESS: "fetch_twitter_timeline_success",
  FETCH_TWITTER_TIMELINE_FAIL: "fetch_twitter_timeline_fail",
  POST_DATA_START: "post_data_start",
  POST_DATA_PARTIAL_SUCCESS: "post_data_partial_success",
  POST_DATA_SUCCESS: "post_data_success",
  POST_DATA_FAIL: "post_data_fail",
  SET_IS_DESO_BALANCE_MODAL: "insufficient_deso_balance",
};

export const pushEvent = (eventName = "custom_event", params = {}) => {
  // eslint-disable-next-line no-undef
  dataLayer.push({
    event: eventName,
    ...params,
  });
};
